<template>
  <div>
    <div class="DealerSpecialOptions">
      <form>
        <div class="grid-layout">
          <div class="inputModule">
            <label for="input-dealerOptionsCustomerAttention">{{
              $mlGet("dealerSpecialOptions-form-CustomerAttention")
            }}</label>
            <input
              name="dealerOptionsCustomerAttention"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerAttention"
              id="input-dealerOptionsCustomerAttention"
            />
          </div>

          <div class="inputModule">
            <label for="input-dealerOptionsCustomerEmail">{{
              $mlGet("dealerSpecialOptions-form-CustomerEmail")
            }}</label>
            <input
              name="dealerOptionsCustomerEmail"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerEmail"
              id="input-dealerOptionsCustomerEmail"
            />
          </div>

          <div class="inputModule">
            <label for="input-dealerOptionsCustomerPhone">{{
              $mlGet("dealerSpecialOptions-form-CustomerPhone")
            }}</label>
            <input
              name="dealerOptionsCustomerPhone"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerPhone"
              id="input-dealerOptionsCustomerPhone"
            />
          </div>
          <div class="information-box" style="grid-column: 1 / span 2;">
            <span v-html="$mlGet('dealerOptions-informationBox-bottom')"></span>
          </div>
        </div>

        <div
          style="grid-column: 1 / span 2; margin: 10px 0; border-top: 1px solid lightgrey;"
        />

        <div class="grid-layout" style="margin-bottom: 8px;">
          <Radio
            style="grid-column: 1;"
            :questionString="$mlGet('input-dealerOptionsPickupDirectly')"
            v-on:userInput="
              input => ($store.state.rma.dealerOptionsPickupDirectly = input)
            "
            :answer="$store.state.rma.dealerOptionsPickupDirectly"
          />
          <Radio
            :questionString="$mlGet('input-dealerOptionsRetourDirectly')"
            v-on:userInput="
              input => ($store.state.rma.dealerOptionsRetourDirectly = input)
            "
            :answer="$store.state.rma.dealerOptionsRetourDirectly"
          />
        </div>

        <div
          v-if="
            $store.state.rma.dealerOptionsPickupDirectly === true ||
              $store.state.rma.dealerOptionsRetourDirectly === true
          "
          class="grid-layout"
        >
          <div class="inputModule">
            <label for="input-dealerOptionsCustomerName">{{
              $mlGet("dealerSpecialOptions-form-CustomerName")
            }}</label>
            <input
              name="dealerOptionsCustomerName"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerName"
              id="input-dealerOptionsCustomerName"
            />
          </div>

          <div class="inputModule">
            <label for="input-dealerOptionsCustomerAttention">{{
              $mlGet("dealerSpecialOptions-form-CustomerAttention")
            }}</label>
            <input
              name="dealerOptionsCustomerAttention"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerAttention"
              id="input-dealerOptionsCustomerAttention"
            />
          </div>

          <!-- Address 1 -->
          <div class="inputModule">
            <label for="input-dealerOptionsCustomerAddress">{{
              $mlGet("dealerSpecialOptions-form-CustomerAddress")
            }}</label>
            <input
              name="dealerOptionsCustomerAddress"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerAddress"
              id="input-dealerOptionsCustomerAddress"
            />
          </div>

          <!-- Address 2 -->
          <div class="inputModule">
            <label for="input-dealerOptionsCustomerAddress2">{{
              $mlGet("dealerSpecialOptions-form-CustomerAddress2")
            }}</label>
            <input
              name="dealerOptionsCustomerAddress2"
              type="text"
              v-model="$store.state.rma.dealerOptionsCustomerAddress2"
              id="input-dealerOptionsCustomerAddress2"
            />
          </div>

          <div
            style="grid-column: 1 / span 2; display: grid; grid-template-columns: 1fr 3fr 1fr; column-gap: 10px;"
          >
            <!-- Postal -->
            <div class="inputModule">
              <label for="input-dealerOptionsCustomerPostal">{{
                $mlGet("dealerSpecialOptions-form-CustomerPostal")
              }}</label>
              <input
                name="dealerOptionsCustomerPostal"
                type="text"
                v-model="$store.state.rma.dealerOptionsCustomerPostal"
                id="input-dealerOptionsCustomerPostal"
              />
            </div>

            <!-- City -->
            <div class="inputModule">
              <label for="input-dealerOptionsCustomerCity">{{
                $mlGet("dealerSpecialOptions-form-dealerOptionsCustomerCity")
              }}</label>
              <input
                name="dealerOptionsCustomerCity"
                type="text"
                v-model="$store.state.rma.dealerOptionsCustomerCity"
                id="input-dealerOptionsCustomerCity"
              />
            </div>

            <!-- Country -->
            <div class="inputModule">
              <label for="input-dealerOptionsCustomerCountry">{{
                $mlGet("dealerSpecialOptions-form-CustomerCountry")
              }}</label>
              <input
                name="dealerOptionsCustomerCountry"
                type="text"
                :value="$store.state.rma.dealerOptionsCustomerCountry"
                id="input-dealerOptionsCustomerCountry"
                readonly
                style="opacity: .5;"
              />
            </div>
          </div>
        </div>

        <div v-else class="information-box" style="grid-column: 1 / span 2;">
          <span
            v-html="$mlGet('dealerOptions-informationBox-directshipping')"
          ></span>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import axios from "axios";

import Radio from "@/components/Input/Radio.vue";
import { Component, Vue, Watch } from "vue-property-decorator";

import { PageChangeContext, PageName } from "@/views/CreateRma.vue";

@Component({
  components: {
    Radio
  }
})
export default class DealerSpecialOptions extends Vue {
  public userCountry: string | null = null;

  public async mounted() {
    if (this.$store.state.rma.dealerOptionsCustomerCountry.length !== 2)
      await this.fetchUserInformation();
  }

  public async fetchUserInformation() {
    const userInformationResponse = await axios.get("/user");

    if (
      typeof userInformationResponse.data?.addressInfo.address_country !==
      "string"
    )
      console.error("Could not fetch user information.");

    this.$store.state.rma.dealerOptionsCustomerCountry =
      userInformationResponse.data.addressInfo.address_country;
  }

  public async beforePageLeave(context: PageChangeContext): Promise<boolean> {
    if (context.isReturnOperation) return true;

    if (this.$store.state.rma.dealerOptionsCustomerAttention.length > 35) {
      await this.$swal(
        this.$mlGet("dealerpage-formerror-attention-head"),
        this.$mlGet("dealerpage-formerror-attention-body"),
        "error"
      );
      return false;
    }

    if (this.$store.state.rma.dealerOptionsCustomerEmail.length > 50) {
      await this.$swal(
        this.$mlGet("dealerpage-formerror-email-head"),
        this.$mlGet("dealerpage-formerror-email-body"),
        "error"
      );
      return false;
    }

    if (this.$store.state.rma.dealerOptionsCustomerEmail.length > 0) {
      // Valiate the email address with a regex
      const emailRegex = new RegExp(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
      );

      if (!emailRegex.test(this.$store.state.rma.dealerOptionsCustomerEmail)) {
        this.$swal(
          this.$mlGet("dealerpage-formerror-email-head"),
          this.$mlGet("dealerpage-formerror-email-body"),
          "error"
        );
        return false;
      }
    }

    if (this.$store.state.rma.dealerOptionsCustomerPhone.length > 15) {
      await this.$swal(
        this.$mlGet("dealerpage-formerror-phone-head"),
        this.$mlGet("dealerpage-formerror-phone-body"),
        "error"
      );
      return false;
    }

    if (
      this.$store.state.rma.dealerOptionsPickupDirectly === true ||
      this.$store.state.rma.dealerOptionsRetourDirectly === true
    ) {
      if (this.$store.state.rma.dealerOptionsCustomerAttention.length === 0) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-attention-head"),
          this.$mlGet("dealerpage-formerror-attention-body"),
          "error"
        );
        return false;
      }

      if (this.$store.state.rma.dealerOptionsCustomerEmail.length < 2) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-email-head"),
          this.$mlGet("dealerpage-formerror-email-body"),
          "error"
        );
        return false;
      }

      if (this.$store.state.rma.dealerOptionsCustomerPhone.length < 6) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-phone-head"),
          this.$mlGet("dealerpage-formerror-phone-body"),
          "error"
        );
        return false;
      }

      if (
        this.$store.state.rma.dealerOptionsCustomerName.length < 2 ||
        this.$store.state.rma.dealerOptionsCustomerName.length > 35
      ) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-name-head"),
          this.$mlGet("dealerpage-formerror-name-body"),
          "error"
        );
        return false;
      }

      if (
        this.$store.state.rma.dealerOptionsCustomerAddress < 2 ||
        this.$store.state.rma.dealerOptionsCustomerAddress > 35 ||
        this.$store.state.rma.dealerOptionsCustomerAddress2 > 35
      ) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-address-head"),
          this.$mlGet("dealerpage-formerror-address-body"),
          "error"
        );
        return false;
      }

      if (
        this.$store.state.rma.dealerOptionsCustomerCity.length < 2 ||
        this.$store.state.rma.dealerOptionsCustomerCity.length > 30
      ) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-city-head"),
          this.$mlGet("dealerpage-formerror-city-body"),
          "error"
        );
        return false;
      }

      if (
        this.$store.state.rma.dealerOptionsCustomerPostal < 1 ||
        this.$store.state.rma.dealerOptionsCustomerPostal.length > 9
      ) {
        await this.$swal(
          this.$mlGet("dealerpage-formerror-postal-head"),
          this.$mlGet("dealerpage-formerror-postal-body"),
          "error"
        );
        return false;
      }
    }

    return true;
  }

  public async afterPageEnter(context: PageChangeContext): Promise<void> {
    return;
  }

  public async onPageLeave(context: PageChangeContext): Promise<PageName> {
    return "WarrantyInformation";
  }

  @Watch("$store.state.rma.dealerOptionsPickupDirectly")
  @Watch("$store.state.rma.dealerOptionsRetourDirectly")
  public onPickupOrRetourChange() {
    if (
      this.$store.state.rma.dealerOptionsPickupDirectly === true ||
      this.$store.state.rma.dealerOptionsRetourDirectly === true
    )
      return;
    this.$store.state.rma.dealerOptionsCustomerAddress = "";
    this.$store.state.rma.dealerOptionsCustomerAddress2 = "";
    this.$store.state.rma.dealerOptionsCustomerCity = "";
    this.$store.state.rma.dealerOptionsCustomerPostal = "";
    this.$store.state.rma.dealerOptionsCustomerName = "";
    this.$store.state.rma.dealerOptionsContactDirectly = -1;
  }
}
</script>

<style scoped>
#headertext {
  padding: 0;
  margin: 0 0 2ex 0;
}

form input {
  border: 1px solid lightgray;
  box-sizing: border-box;
  padding: 4px;
  margin: 3px 0;
  width: 100%;
}

textarea {
  border: 1px solid lightgray;
  box-sizing: border-box;
  width: 100%;
  height: 10vh;
  font-family: sans-serif;
  resize: none;
}

.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
}

.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}
</style>
